import React from "react";
import styled from "styled-components";
import { Link, withRouter } from "react-router-dom";
import { graphql, QueryRenderer } from "react-relay";
import { Body } from "../Certificates";
import { NavStrip, LightBoxModal, HelmetTitle } from "../../Components/Utils";
import Layout from "../../Components/Layout";
import environment from "../../Environment";
import Navigation from "../BannerItems/Components/Navigation";
import { PictureLayer } from "./EventsBox";

import NCISmarkdown from "./Contents/NCIS.md";
import APPMmarkdown from "./Contents/APPM.md";
import ChallengeCupmarkdown from "./Contents/ChallengeCup2017.md";
import Esutmarkdown from "./Contents/Esut.md";
import IHack17markdown from "./Contents/IHack2017.md";
import PM18markdown from "./Contents/PMvisit2018.md";
import Unilagmarkdown from "./Contents/Unilag.md";
import TEBIndiamarkdown from "./Contents/TEBIndia.md";
import TEBCIAPmarkdown from "./Contents/TEBCIAP.md";
import UnilagNCISmarkdown from "./Contents/ncis-2018-event.md";
import VisitUnilagmarkdown from "./Contents/2018-visit-unilag.md";

const query = graphql`
  query Experiences_Query($page: String!) {
    bootcamps(pagePath: $page) {
      id
      name
      src
      srcMain
      caption
    }
  }
`;
const BackLink = styled.span`
  color: hsl(0, 0%, 17%);
  text-decoration: none;
  border-bottom: 1px solid hsl(217, 40%, 40%);
  display: inline-block;
  background-color: transparent;
  transition: all .2s ease-out;
  float: left;
  margin-left: 30px;
  padding: 2px 10px;
  cursor: pointer;

  &:hover {
    background-color: hsl(217, 40%, 40%);
    color: #fff;
    border-bottom-color: transparent;
  }
`;

class Experiences extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentLightBoxImage: 0,
      isLightBoxOpen: false
    };
    this.headBack = this.headBack.bind(this);
    this.handleGrabLightBox = this.handleGrabLightBox.bind(this);
    this.gotoLightBoxPrev = this.gotoLightBoxPrev.bind(this);
    this.gotoLightBoxNext = this.gotoLightBoxNext.bind(this);
    this.handleLightBoxClose = this.handleLightBoxClose.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  componentDidUpdate(prevProps) {
    if(prevProps.match.params.experience !== this.props.match.params.experience) {
      window.scrollTo(0, 0);
    }
  }
  handleGrabLightBox(event) {
   const imageIndex = Number(event.target.getAttribute('data-index')) || 0;
   this.setState({
    currentLightBoxImage: imageIndex,
    isLightBoxOpen: true,
   });  
  }
  gotoLightBoxPrev() {
    this.setState((prevState) => ({
      currentLightBoxImage: prevState.currentLightBoxImage - 1,
    }));
  }
  gotoLightBoxNext() {
    this.setState((prevState) => ({
      currentLightBoxImage: prevState.currentLightBoxImage + 1,
    }));
  }
  handleLightBoxClose() {
    this.setState({
      currentLightBoxImage: 0,
      isLightBoxOpen: false
    })
  }
  getPage (experiencePage) {
    const pageParam = experiencePage.toLowerCase();
    switch (pageParam) {
      case "ncis":
        return NCISmarkdown;
      case "appm":
        return APPMmarkdown;
      case "challengecup2017":
        return ChallengeCupmarkdown;
      case "esut":
        return Esutmarkdown;
      case "ihack2017":
        return IHack17markdown;
      case "pmvisit2018":
        return PM18markdown;
      case "unilag":
        return Unilagmarkdown;
      case "venture-scalecamp-india":
        return TEBIndiamarkdown;
      case "venture-scalecamp-ciap":
        return TEBCIAPmarkdown;
      case "ncis-2018-abuja-nigeria":
        return UnilagNCISmarkdown;
      case "2018-visit-to-unilag-lagos":
        return VisitUnilagmarkdown;
      default:
        return false;
    }
  }
  
  headBack(e) {
    e.stopPropagation();
    this.props.history.goBack();
  }

  render() {      
    let experiencePage = this.props.match.params.experience;
    experiencePage = experiencePage.toLowerCase();
    return (
      <div className="App">
        <HelmetTitle title={`Experiences / ${experiencePage.toLowerCase()}`} />
        <Layout
          head={
            <React.Fragment>
              <Navigation />
              <NavStrip />
            </React.Fragment>
          }
          body={ 
            <React.Fragment>
              {
                this.getPage(experiencePage) &&
                <Body markdownPath={this.getPage(experiencePage)} />
              }
              {
                experiencePage &&
                <QueryRenderer
                  query={query}
                  environment={environment}
                  variables={{ page: experiencePage }}
                  render={({ error, props}) => {
                    console.log('experiencePage', experiencePage)
                    if (error || (props && !props.bootcamps)) {
                      return <div>Error</div>;
                    }

                    if (!props) {
                      return <div>Loading...</div>;
                    }
                    let bootcamp = props.bootcamps;
                    console.log('bootcamp here..', bootcamp);
                    return (
                      <div>
                        <PictureLayer pictures={bootcamp} handleGrabLightBox={this.handleGrabLightBox} />
                        <LightBoxModal 
                          pictures={bootcamp}
                          isLightBoxOpen={this.state.isLightBoxOpen}
                          gotoLightBoxPrev={this.gotoLightBoxPrev}
                          gotoLightBoxNext={this.gotoLightBoxNext}
                          handleLightBoxClose={this.handleLightBoxClose}
                          isCurrentLightBoxImage={this.state.currentLightBoxImage}
                          />
                      </div>
                    )
                    
                  }}
                  />
              }
            </React.Fragment>
          }
        />
      </div>  
    );
  }
}


export default withRouter(Experiences)



// WEBPACK FOOTER //
// ./src/Pages/Experiences/index.js